import { normaliseNonOrderProductCheckInInputField } from "src/helpers/productCheckInHelper";
import { IdGenerator } from "src/utils";
import { ProductCheckInFieldKey } from "src/enums";
import {
  PostWarehouseCheckInUnknownArrivalRequestBody,
  NonOrderProductCheckInInputField,
  CheckInUnknownArrivalFormData
} from "src/types";

export class CheckInUnknownArrivalMapper {
  public static initNonOrderProductCheckInInputField(): NonOrderProductCheckInInputField {
    return {
      receivedQty: "",
      receivedUkQty: "",
      receivedEuQty: "",
      hasWarehouseSplit: true,
      expiryDates: [{ date: "", qty: "" }],
      fieldId: IdGenerator.generateUniqueElementId(),
      fieldKey: ProductCheckInFieldKey.NonOrderProductCheckIn,
      productId: "",
      productName: ""
    };
  }

  public static initCheckInUnknownArrivalFormData(): CheckInUnknownArrivalFormData {
    return {
      vendorName: "",
      asn: "",
      reasonForUnknownArrival: "",
      additionalDetails: "",
      nonOrderProductCheckIns: [CheckInUnknownArrivalMapper.initNonOrderProductCheckInInputField()],
      checkInImages: []
    };
  }

  public static checkInUnknownArrivalRequestBodyFromFormData(
    checkInUnknownArrivalFormData: CheckInUnknownArrivalFormData
  ): PostWarehouseCheckInUnknownArrivalRequestBody {
    const normalisedProductCheckIns = checkInUnknownArrivalFormData.nonOrderProductCheckIns.map(
      normaliseNonOrderProductCheckInInputField
    );

    const normalisedAdditionalDetails = checkInUnknownArrivalFormData.additionalDetails || undefined;

    return {
      timestamp: new Date().toISOString(),
      vendorName: checkInUnknownArrivalFormData.vendorName,
      asn: checkInUnknownArrivalFormData.asn,
      reasonForUnknownArrival: checkInUnknownArrivalFormData.reasonForUnknownArrival,
      additionalDetails: normalisedAdditionalDetails,
      productCheckIns: normalisedProductCheckIns
    };
  }
}
